<script>
  export let id = "";
</script>

<div>
  <iframe
    id="ytplayer"
    type="text/html"
    width="640"
    height="360"
    src="https://www.youtube.com/embed/{id}?autoplay=1&modestbranding=1&origin=http://example.com"
    frameborder="0"
  />
</div>

<style>
  div {
    position: relative;
    padding-bottom: 56.25%; /* 16:9 */
    height: 0;
  }
  div iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
</style>
